import {Banner} from '@sdox/ui'

import {GenericButton} from '../Buttons/GenericButton'

import type {BlockBannerFragment} from '@sdox/api'

export const BlockBanner = (props: BlockBannerFragment) => {
  const {cta, bannerBackground, bannerTitle} = props
  const hasImage = bannerBackground && !bannerBackground.isPlaceholder

  return (
    <Banner
      backgroundImage={hasImage ? bannerBackground.thumbnailUrl : undefined}
      heading={bannerTitle}
      action={(
        cta ? <GenericButton {...cta} /> : undefined
      )}
    />
  )
}
